'use client';

import type { ProductDetailData } from '@eliadmin/core/src/api/products/types/product-types';

import { ProductTabContainer } from './product-tab-container';

export function ProductTabVideo({ product, title }: { product: ProductDetailData; title: string }) {
  const videoUrl = product.video?.startsWith('http')
    ? product.video
    : `https://${product.video}`;

  return (
    <ProductTabContainer title={title}>
      <iframe
        src={videoUrl}
        title={title}
        allowFullScreen
        className="aspect-video w-full rounded-[16px]"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      ></iframe>
    </ProductTabContainer>
  );
}